var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 14.5,
    fill: "#0D0D0D",
    stroke: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2071 32.7071C28.8166 33.0976 28.1834 33.0976 27.7929 32.7071L21.7929 26.7071C21.4024 26.3166 21.4024 25.6834 21.7929 25.2929L27.7929 19.2929C28.1834 18.9024 28.8166 18.9024 29.2071 19.2929C29.5976 19.6834 29.5976 20.3166 29.2071 20.7071L23.9142 26L29.2071 31.2929C29.5976 31.6834 29.5976 32.3166 29.2071 32.7071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.47f2bdecc860ef6b5d0ee95cd1befafa.svg";
export { ForwardRef as ReactComponent };